module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "odds_changes"
    }
  }, [_c('div', {
    attrs: {
      "id": "teamHeader"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.teamData.matchTime) + " " + _vm._s(_vm.teamData.matchCompetition) + " Round " + _vm._s(_vm.teamData.matchRound))]), _vm._v(" "), (_vm.teamData.teamA) ? _c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.teamData.teamA.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.teamData.teamA.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_vm._v("\n        VS\n    ")]), _vm._v(" "), (_vm.teamData.teamB) ? _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.teamData.teamB.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.teamData.teamB.name))])]) : _vm._e()]), _vm._v(" "), _c('nav', [_c('span', [_vm._v(_vm._s(_vm.$t("odds_company")))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("odds_dc")))])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('aside', {
    staticClass: "menu"
  }, _vm._l((_vm.betList), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        'sel': index === _vm.currentSelectedCompanyIdIndex
      },
      on: {
        "click": function($event) {
          _vm.changeNav(item.company.companyId, index)
        }
      }
    }, [_vm._v(_vm._s(item.company.name))])
  })), _vm._v(" "), _c('article', [_c('table', _vm._l((_vm.currentData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "firstTd"
    }, [(index == (_vm.currentData.length - 1)) ? _c('span', {
      staticClass: "frist"
    }, [_vm._v(_vm._s(_vm.$t("odds_initial")))]) : _vm._e(), _vm._v("\n                  " + _vm._s(_vm.oddsFormat(item.homeWin)) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat(item.draw)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat(item.awayWin)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.time))])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dbfcaa0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppMatchOdds.vue
// module id = 763
// module chunks = 11